import { TrendingUp, TrendingDown } from 'lucide-react';

export const MetricCard = ({ label, value, trend, trendValue, icon: Icon }) => {
  const isPositive = trend === 'up';
  
  return (
    <div 
      className="flex flex-col gap-2 p-6 bg-white rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-200"
      data-testid="metric-card"
    >
      <div className="flex items-center justify-between">
        <span className="text-sm text-slate-500 font-medium uppercase tracking-wider">
          {label}
        </span>
        {Icon && (
          <div className="p-2 bg-slate-100 rounded-lg">
            <Icon size={20} className="text-[#1a365d]" />
          </div>
        )}
      </div>
      
      <div className="flex items-end gap-2">
        <span className="text-3xl font-bold text-[#1a365d] font-heading">
          {value}
        </span>
        
        {trendValue && (
          <span className={`text-sm flex items-center gap-1 mb-1 ${
            isPositive ? 'text-emerald-600' : 'text-red-600'
          }`}>
            {isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
            {trendValue}
          </span>
        )}
      </div>
    </div>
  );
};
